import isValueEmpty from 'hb-react/shared/utils/isValueEmpty';

export const errorMessage = s__(
  'Validators|You can select up to %{maxArrayLength} items maximum',
);

export const validateMaxArrayLength = (
  value,
  maxArrayLength,
  maxArrayLengthErrorMessage,
) => {
  let error;

  if (isValueEmpty(value) || !Array.isArray(value)) {
    return error;
  }

  if (value.length > maxArrayLength) {
    error = maxArrayLengthErrorMessage
      ? maxArrayLengthErrorMessage.i__({ maxArrayLength })
      : errorMessage.i__({ maxArrayLength });
  }

  return error;
};
